import { render, staticRenderFns } from "./CustomerInstagram.vue?vue&type=template&id=2e9d8442"
import script from "./CustomerInstagram.vue?vue&type=script&lang=js"
export * from "./CustomerInstagram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports